module.exports = __webpack_public_path__ + "img/olist-envios.8e863460.svg";